import React, { useRef, useLayoutEffect, useContext } from "react";
import { status } from "../constants";
import { AppContextProvider } from "../App";

export default function Checkbox(props) {
  const { indeterminate, checked, id, compute, name, ...rest } = props;
  const inputRef = useRef(null);
  const { setFilteredItems, filteredItems, setCancelBtn } =
    useContext(AppContextProvider);
  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
      inputRef.current.checked = checked;
    }
  }, [indeterminate, checked]);

  return (
    <input
      {...rest}
      ref={inputRef}
      type="checkbox"
      onChange={(e) => {
        const newStatus = inputRef.current.checked
          ? status.checked
          : status.unchecked;
        compute(id, newStatus);
        if (inputRef.current.checked == true) {
          setFilteredItems((prev) => [...prev, { id, name, newStatus }]);
          setCancelBtn(false);
          console.log(newStatus);
        }
      }}
    />
  );
}
